<div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1em">
  <h2 mat-dialog-title>{{ "appointments.gui.labels.changes" | translate }}</h2>
  <button style="margin: 0 0 20px" mat-button mat-dialog-close aria-label="close">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content *ngIf="displayChanges.length; else noChanges">
  <table>
    <tr *ngFor="let change of displayChanges" style="display: flex; gap: 2em">
      <td>
        <strong>{{ "appointments.gui.labels.changed on" | translate }}:</strong>
        {{ change.actionDate | date : "dd.MM.yy HH:mm" }}
      </td>
      <td>
        <strong>{{ "appointments.gui.labels.by" | translate }}:</strong>
        <span *ngIf="change.changedBy === 'user'">
          {{ change.performedByName || ("appointments.gui.labels.secretary" | translate) }}
        </span>
        <span *ngIf="change.changedBy !== 'user'">
          {{ "appointments.gui.labels.patient" | translate }}
        </span>
      </td>

      <!-- date -->
      <ng-container *ngIf="isDateField">
        <td>
          <strong>{{ "appointments.gui.labels.previous date" | translate }}:</strong>
          {{ change.oldValue | date : "dd.MM.yy HH:mm" }}
        </td>
        <td>
          <strong>{{ "appointments.gui.labels.new date" | translate }}:</strong>
          {{ change.newValue | date : "dd.MM.yy HH:mm" }}
        </td>
      </ng-container>

      <!-- exam type -->
      <ng-container *ngIf="isExamField">
        <td>
          <strong>{{ "appointments.gui.labels.previous exam type" | translate }}:</strong>
          {{ change.oldValue }}
        </td>
        <td>
          <strong>{{ "appointments.gui.labels.new exam type" | translate }}:</strong>
          {{ change.newValue }}
        </td>
      </ng-container>

      <!-- duration -->
      <ng-container *ngIf="!isDateField && !isExamField && field === 'aptlength'">
        <td>
          <strong>{{ "appointments.gui.labels.previous duration" | translate }}:</strong>
          {{ change.oldValue }} {{ "appointments.gui.labels.min" | translate }}
        </td>
        <td>
          <strong>{{ "appointments.gui.labels.new duration" | translate }}:</strong>
          {{ change.newValue }} {{ "appointments.gui.labels.min" | translate }}
        </td>
      </ng-container>

      <!-- doctor -->
      <ng-container *ngIf="!isDateField && !isExamField && field === 'DocUID'">
        <td>
          <strong>{{ "appointments.gui.labels.previous doctor" | translate }}:</strong>
          {{ change.oldValue }}
        </td>
        <td>
          <strong>{{ "appointments.gui.labels.new doctor" | translate }}:</strong>
          {{ change.newValue }}
        </td>
      </ng-container>

      <!-- completed -->
      <ng-container *ngIf="isCompletedField">
        <td>
          <strong>{{ "appointments.gui.labels.previous status" | translate }}:</strong>
          {{
            change.oldValue
              ? ("appointments.gui.labels.yes" | translate | titlecase)
              : ("appointments.gui.labels.no" | translate | titlecase)
          }}
        </td>
        <td>
          <strong>{{ "appointments.gui.labels.new status" | translate }}:</strong>
          {{
            change.newValue
              ? ("appointments.gui.labels.yes" | translate | titlecase)
              : ("appointments.gui.labels.no" | translate | titlecase)
          }}
        </td>
      </ng-container>

      <!-- arrival confirmation -->
      <ng-container *ngIf="isArrivalConfirmedField">
        <td>
          <strong>{{ "appointments.gui.labels.previous status" | translate }}:</strong>
          {{
            change.oldValue
              ? ("appointments.gui.labels.confirmed" | translate)
              : ("appointments.gui.labels.declined" | translate)
          }}
        </td>
        <td>
          <strong>{{ "appointments.gui.labels.new status" | translate }}:</strong>
          {{
            change.newValue
              ? ("appointments.gui.labels.confirmed" | translate)
              : ("appointments.gui.labels.declined" | translate)
          }}
        </td>
      </ng-container>

      <!-- doctor -->
      <ng-container *ngIf="isDoctorField">
        <td>
          <strong>{{ "appointments.gui.labels.previous doctor" | translate }}:</strong>
          {{ change.oldValue }}
        </td>
        <td>
          <strong>{{ "appointments.gui.labels.new doctor" | translate }}:</strong>
          {{ change.newValue }}
        </td>
      </ng-container>

      <!-- room -->
      <ng-container *ngIf="isRoomField">
        <td>
          <strong>{{ "appointments.gui.labels.previous room" | translate }}:</strong>
          {{ change.oldValue }}
        </td>
        <td>
          <strong>{{ "appointments.gui.labels.new room" | translate }}:</strong>
          {{ change.newValue }}
        </td>
      </ng-container>
    </tr>
  </table>
</mat-dialog-content>

<ng-template #noChanges>
  <p>{{ "appointments.gui.labels.no changes available" | translate }}</p>
</ng-template>
